    
     import React, { useState } from 'react';
import Axios from 'axios';
import './Contact.css'
import Swal from 'sweetalert2';

const Contactus = () => {

    const url = "https://auraairline.com/aura_airlines/CustomerContactDetails"

    const [data, setData] = useState({
        cus_name: '',
        email: '',
        mobi_num: '',
        message: ''
    });

    function submit(e){
        
        e.preventDefault();

        Axios.post(url,{
            cus_name:data.cus_name,
            email:data.email,
            mobi_num:data.mobi_num,
            message:data.message
        })
            .then(res=>{
                const responseData = res.data;
                console.log(responseData);

                if (responseData.status === 'SUCCESS') {
                    Swal.fire({
                        title: 'Success',
                        text: 'Thank you for getting in touch! We appreciate you contacting us.',
                    }).then(() => {
                        // Reset the form
                        setData({
                            cus_name:"",
                            email:"",
                            mobi_num:"",
                            message:""
                        });
                    });
                    
                } else {
                    // Handle other response statuses or errors
                    Swal.fire({
                        title: 'Error',
                        text: 'Oops! Somthing went wrong. Please try again.',
                    });
                }

            })
            .catch(error => {
                console.error("An error occurred:", error);
                Swal.fire({
                    title: 'Error',
                    text: 'An error occurred while processing your request. Please try again later.',
                });
            });
                
        setData({
            cus_name:"",
            email:"",
            mobi_num:"",
            message:""
          });

    }

    function handle(e){
        const newdata={...data}
        newdata[e.target.id] = e.target.value
        setData(newdata)
        /*console.log(newdata)*/

    }

    return (
        <>
            <div class="container-fluid page-header_contact"><br /><br /><br />
                <h1 class="display-3 text-uppercase text-white mb-3">Contact / Inquire</h1>
                <div class="d-inline-flex text-white">
                    <h6 class="text-uppercase m-0"><a class="text-white" href="/">HOME</a></h6>
                    <h6 class="text-body m-0 px-3">/</h6>
                    <h6 class="text-uppercase text-body m-0">Contact & Inquire</h6>
                </div>
            </div>

            <div class="container-fluid wow fadeInUp background" data-wow-delay="0.1s">
                <div class="container py-5">
                    <div class="section_title_div text-center position-relative pb-3 mb-0 mx-auto" style={{ maxwidth: '600px' }}>
                        <h5 class="fw-bold text-primary text-uppercase">Contact Us</h5>
                        <h1 class="mb-0">If You Have Any Query, Feel Free To Contact Us</h1>
                    </div>
                   
                    <div class="row g-0">
                        <div class="col-lg-7 wow slideInUp" data-wow-delay="0.3s">
                            <form id="contactForm" onSubmit={(e)=> submit(e)}>
                                <div class="row g-3">
                                    <div class="col-md-6">
                                        <input type="text" class="form-control border-0 bg-light px-4" placeholder="Your Name" onChange={(e)=>handle(e)} id="cus_name" value={data.cus_name} style={{ height: '55px' }} />
                                    </div>
                                    <div class="col-md-6">
                                        <input type="email" class="form-control border-0 bg-light px-4" placeholder="Your Email" onChange={(e)=>handle(e)} id="email" value={data.email} style={{ height: '55px' }} />
                                    </div>
                                    <div class="col-12">
                                        <input type="text" class="form-control border-0 bg-light px-4" placeholder="Contact Number" onChange={(e)=>handle(e)} id="mobi_num" value={data.mobi_num} style={{ height: '55px' }} />
                                    </div>
                                    <div class="col-12">
                                        <textarea class="form-control border-0 bg-light px-4 py-3" rows="4" onChange={(e)=>handle(e)} id="message" value={data.message} placeholder="Message"></textarea>
                                    </div>
                                    <div class="col-12">
                                        <button class="btn btn-primary w-100 py-3" id="contactBtn" value="S E N D  M E S S A G E" type="submit">Send Message</button>
                                    </div>
                                </div>
                            </form>
                        </div>

                        <div class="col-lg-5 mb-0">
                            <div class="bg-secondary-contact d-flex flex-column justify-content-center px-5 mb-4" style={{ height: '360px' }}>
                                <div class="d-flex mb-3">
                                    <i class="fa fa-2x fa-phone-alt text-primary flex-shrink-0 mr-3"></i>
                                    <div class="mt-n1">
                                        <h5>Call to ask any question</h5>
                                        <p>+94 77 907 1437</p>
                                    </div>
                                </div>
                                <div class="d-flex mb-3">
                                    <i class="fa fa-2x fa-phone-alt text-primary flex-shrink-0 mr-3"></i>
                                    <div class="mt-n1">
                                        <h5>Call to ask any question</h5>
                                        <p>+94 77 907 1437</p>
                                    </div>
                                </div>
                                <div class="d-flex mb-3">
                                    <i class="fa fa-2x fa-map-marker-alt text-primary flex-shrink-0 mr-3"></i>
                                    <div class="mt-n1">
                                        <h5>Email to get free quote</h5>
                                        <p>info@auraailines.com</p>
                                    </div>
                                </div>
                                <div class="d-flex mb-3">
                                    <i class="fa fa-2x fa-envelope-open text-primary flex-shrink-0 mr-3"></i>
                                    <div class="mt-n1">
                                        <h5>Visit our office</h5>
                                        <p>Colombo International Airport. Ratmalana, Sri Lanka</p>
                                    </div>
                                </div>
                                
                            </div>
                        </div>

                        
                    </div>

                    <div class="col-lg-12 wow slideInUp" data-wow-delay="0.6s">
                            <iframe class="position-relative rounded w-100 h-100"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3961.5781096281066!2d79.88604457478648!3d6.821054719634455!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae25ace5672d713%3A0x19455164f827004b!2sColombo%20International%20Airport%20Ratmalana!5e0!3m2!1sen!2slk!4v1695010005347!5m2!1sen!2slk"
                                frameborder="0" style={{ minHeight: '350px', border: '0' }} allowfullscreen="" aria-hidden="false"
                                tabindex="0"></iframe>
                    </div>

                </div>
            </div>

        </>
    )
}

export default Contactus